interface LegendEntry {
  label: string;
  color: string;
  /** Drawn as a translucent block rather than a solid dot, to match a filled band. */
  muted?: boolean;
}

/** For two or more series a legend is always present, so identity never rests on colour alone. */
export function Legend({ entries }: { entries: LegendEntry[] }) {
  return (
    <div className="legend">
      {entries.map((entry) => (
        <span className="legend__item" key={entry.label}>
          <span
            className="legend__swatch"
            style={{ background: entry.color, opacity: entry.muted ? 0.32 : 1 }}
          />
          {entry.label}
        </span>
      ))}
    </div>
  );
}
